import React from 'react';
import BarcodeReader from 'react-barcode-reader';

const CodeReader = ({ onScan }) => {
  return (
    <div className="CodeReader">
      <BarcodeReader
        onError={(err) => console.log('err', err)}
        onScan={(data) => (onScan ? onScan(data) : console.log('data', data))}
      />
    </div>
  );
};

export default CodeReader;
